import { defineStore } from 'pinia';
import api from '@/services/api';

export const useRecursoTipoStore = defineStore('recursoTipoStore', {
  state: () => ({
    recursoTipoList: [],
    page: 1,
  }),
  actions: {
    async findAllRecursoTipoHTTP() {
      const result = await api.get('/recurso-tipo', { params: { page: +this.page } });
      if (result && result.data) {
        this.recursoTipoList.splice(0, this.recursoTipoList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstRecursoTipo() {
      this.setPage(1);
      this.emptyList();
      await this.findAllRecursoTipoHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.recursoTipoList = [];
    },
  },
});
